module.exports = __webpack_public_path__ + "img/coming-soon.dfacf996.svg";